import React from "react";

const VillagePortal = () => {
  return (
    <div>
      <h1>Village Infra Offering Portal</h1>
      <p>Access and manage village infrastructure offerings.</p>
    </div>
  );
};

export default VillagePortal;
